import { apiClient, apiClientAuth } from "../http/httpClient";


export function UserApi(contentType = "application/json")
{
    const http = apiClient(contentType);
    const https = apiClientAuth(contentType);

    return {

        /**
        * Route publique - Authentification
        * POST /api/users/login
        */
        auth : (data) => http.post("/api/users/login", data), 

        /**
        * Route publique - Mot de passe oublié
        * POST /api/users/forgot-password
        */
        genPasswordToken : (email) => http.post("/api/users/forgot-password", email), 

        /**
        * Route protégée - Récupérer l'utilisateur courant
        * GET /api/users/current/me
        */
        findCurUser: () => https.get(`/api/users/current/me`),

        /**
        * Route protégée - Récupérer tous les utilisateurs (Admin uniquement)
        * GET /api/users
        */
        findAll: () => https.get(`/api/users`),

        /**
        * Route protégée - Récupérer le nombre d'utilisateurs par statut (Admin uniquement)
        * GET /api/users/count/status
        */
        getCount: () => https.get(`/api/users/count/status`),
        
        /**
        * Route protégée - Récupérer un utilisateur par ID
        * GET /api/users/:id
        */
        findOne: (id) => https.get(`/api/users/${id}`),

        /**
        * Route protégée - Modifier le statut d'un utilisateur (Admin uniquement)
        * PUT /api/users/:id/status
        */
        updateStatus : (id, status) => https.put(`/api/users/${id}/status`, status), 

      };
}

